import { AxiosResponse } from 'axios';

import { EmployeeDisplayProps } from 'actions/application';
import { IntermediaryVariables } from 'enums/IntermediaryVariables';
import {
  BusinessEntityStructure,
  MainContactPosition,
  PrimaryHomeImprovementCategory,
} from 'pages/ContractorPortal/steps/ContractorApplication/contractorApplication.enums';
import { OwnerInformation } from 'pages/ContractorPortal/steps/ContractorApplication/contractorApplications.types';

import { HttpClient } from './HttpClient';

export interface ContractorGeneralDataProps {
  [IntermediaryVariables.UTMSource]: string | null;
  [IntermediaryVariables.UTMMedium]: string | null;
  [IntermediaryVariables.UTMCampaign]: string | null;
  [IntermediaryVariables.CampaignID]: string | null;
  [IntermediaryVariables.ADGroupID]: string | null;
  [IntermediaryVariables.Network]: string | null;
  [IntermediaryVariables.Device]: string | null;
  [IntermediaryVariables.Refer]: string | null;
  [IntermediaryVariables.SourceType]: string | null;
  [IntermediaryVariables.SourceName]: string | null;
  intermediary_prequal_link_used: string;
}

export interface CreateIntermediaryApplicationRequestDto {
  contractorApplication: IntermediaryApplicationProps;
  generalData: ContractorGeneralDataProps;
}

export interface IntermediaryApplicationProps {
  intermediary_business_name: string;
  intermediary_corporate_entity_name: string;
  intermediary_federal_tax_id: string;
  intermediary_business_entity_structure: BusinessEntityStructure;
  intermediary_year_of_incorporation: string;
  intermediary_phone: string;
  intermediary_email: string;
  intermediary_corporate_address_information: Address;
  intermediary_mailing_address_information: Address;
  intermediary_website_or_facebook_page: string;
  intermediary_how_did_you_hear_about_us: string;
  intermediary_states_of_operation: string[];
  intermediary_primary_home_improvement_category: PrimaryHomeImprovementCategory;
  intermediary_other_home_improvement_category: PrimaryHomeImprovementCategory[];
  intermediary_do_you_install_the_products_you_sell: boolean;
  intermediary_installer_count: number | null;
  intermediary_associated_manufacturer_1: string;
  intermediary_associated_manufacturer_2: string;
  intermediary_annual_sales: number;
  intermediary_average_jobs: number;
  intermediary_percent_of_sales_financed: number;
  intermediary_years_in_business: number;
  intermediary_hold_appropriate_license: boolean;
  intermediary_hold_appropriate_license_description: string | null;
  intermediary_main_contact_first_name: string;
  intermediary_main_contact_last_name: string;
  intermediary_main_contact_phone: string;
  intermediary_main_contact_email: string;
  intermediary_main_contact_position: MainContactPosition;
  intermediary_total_owners: number;
  intermediary_owners: OwnerInformation[];
  intermediary_other_home_improvement_type: string;
  intermediary_who_signed_master_dealer_agreement: string;
  intermediary_authorized_signer_first_name?: string | null;
  intermediary_authorized_signer_last_name?: string | null;
  intermediary_authorized_signer_position?: string | null;
  intermediary_prequal_link_used: string;
}

export interface Address {
  streetName: string;
  streetNumber: string;
  city: string;
  stateOrProvince: string;
  zipOrPostalCode: string;
  county?: string | null;
}

export interface CreateIntermediaryApplicationResponseDto {
  csm: EmployeeDisplayProps | null;
  created: boolean;
  alreadyExistingEmail?: string;
}

export default class IntermediaryApplicationsApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/intermediary-applications' || '');
  }

  public async createIntermediaryApplication(intermediaryApplicationData: CreateIntermediaryApplicationRequestDto) {
    return this.instance
      .post('', {
        contractorApplication: intermediaryApplicationData.contractorApplication,
        generalData: intermediaryApplicationData.generalData,
      })
      .then((response: AxiosResponse<CreateIntermediaryApplicationResponseDto>) => response.data);
  }
}

export const intermediaryApplicationsApi = new IntermediaryApplicationsApi();
